import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";

export const DEFAULT_DIAL_UP_CODE = "+91";

export const checkout_form = {
    session_details: {
        field_names: {
            selected_schedule: "selected_schedule",
        },
        placeholders: {
            selected_schedule: "Select Session",
        },
    },
    timezone_details: {
        field_names: {
            timezone_data: "timezone_data", // the main field in the payment details form side
            timezone_data_description_section:
                "timezone_data_description_section", // duplicate field in listing details section
        },
        placeholders: {
            timezone_data: "Set Timezone",
        },
    },
    user_details: {
        title: "Purchase Details",
        field_names: {
            name: "name",
            email: "email",
            phone: "phone",
            country_code: "country_code",
            billing_state: "billing_state",
        },
        placeholders: {
            name: "Name",
            email: "Email",
            email_optional: "Email (Optional)",
            phone: "Phone Number",
            billing_state: "State",
            billing_state_optional: "State (Optional)",
        },
    },
    gst_details: {
        title: "I have a GST Number",
        field_names: {
            active: "active",
            company_name: "company_name",
            registration_number: "registration_number",
            state: "state",
            company_address: "company_address",
            company_pincode: "company_pincode",
        },
        placeholders: {
            company_name: "Registered Company Name",
            registration_number: "GST Number",
            state: "State",
            state_optional: "State (Optional)",
            company_address: "Company Address",
            company_pincode: "Company Pincode",
        },
    },
    international_details: {
        title: "",
        field_names: {
            street_address: "street_address",
            town_city: "town_city",
            user_state: "user_state",
            postal_code: "postal_code",
            payment_method: "payment_method",
        },
        placeholders: {
            street_address: "Street Address",
            town_city: "Town/City",
            user_state: "State",
            postal_code: "Postal Code",
            payent_method: "Select Payment Method",
        },
    },
    terms_and_conditions_details: {
        field_names: {
            agree_to_terms_and_conditions: "agree_to_terms_and_conditions",
        },
    },
} as const;

export const checkout_form_error_strings = {
    required: "Required",
    invalid_email: "Invalid Email",
    submit_all: "Fill all required information",
    phone_already_exists: "User with this phone number already exists",
    email_already_exists: "User with this email already exists",
};

/**
 * session selector enum gives the key name in which data will be stored in the react-hook form
 * it is different based upon listing types
 */
export const session_selector_enum: {
    [key: string]: "slots" | "batches";
} = {
    [LISTING_TYPES.WORKSHOPS]: "slots",
    [LISTING_TYPES.WEBINAR]: "slots",
    [LISTING_TYPES.APPOINTMENTS]: "slots",
    [LISTING_TYPES.GROUP_CLASSES]: "batches",
    [LISTING_TYPES.ROLLING_CLASSES]: "batches",
    [LISTING_TYPES.ONE_ON_ONE_CLASSES]: "batches",
};

export const multiple_user_count_key = "multiple_user_count";
